

const Currencies = ['PLN', 'EUR', 'USD', 'CHF' , 'GBP', 'NOK']

export default Currencies;
